/**
 * Arrows for the cart drawer's "Passt dazu" row (desktop).
 *
 * The drawer markup is re-rendered (morphed) after every cart change while
 * the row element itself may keep its scroll position, so the arrow states
 * are re-synced after every DOM change instead of trusting the markup.
 * Arrows jump card by card to exact snap positions (no scrollBy + CSS smooth
 * scrolling fighting each other).
 */
(function () {
  if (window.__cartXsArrows) return;
  window.__cartXsArrows = true;

  var ROW = '.cart-drawer__cross-sell-row';

  function cardsOf(row) {
    return Array.prototype.slice.call(row.querySelectorAll('.cart-cross-sell__card'));
  }

  function offsets(row) {
    var cards = cardsOf(row);
    if (!cards.length) return [];
    var first = cards[0].offsetLeft;
    var max = Math.max(0, row.scrollWidth - row.clientWidth);
    return cards.map(function (card) {
      return Math.min(card.offsetLeft - first, max);
    });
  }

  function sync(row) {
    var nav = row.parentElement && row.parentElement.querySelector('.cart-drawer__cross-sell-nav');
    if (!nav) return;
    // Closed drawer = row not laid out (width 0): don't hide the arrows based on
    // that, otherwise they stay hidden after opening until some later DOM change.
    if (!row.clientWidth) return;
    var max = row.scrollWidth - row.clientWidth;
    var prev = nav.querySelector('[data-xs-dir="-1"]');
    var next = nav.querySelector('[data-xs-dir="1"]');
    nav.hidden = max <= 2;
    if (prev) prev.disabled = row.scrollLeft <= 2;
    if (next) next.disabled = row.scrollLeft >= max - 2;
  }

  function syncAll() {
    document.querySelectorAll(ROW).forEach(sync);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.cart-drawer__cross-sell-arrow');
    if (!button) return;
    var row = button.closest('.cart-drawer__cross-sell').querySelector(ROW);
    if (!row) return;
    var stops = offsets(row);
    if (!stops.length) return;

    // index of the card currently at the left edge
    var current = 0;
    for (var i = 0; i < stops.length; i++) {
      if (Math.abs(stops[i] - row.scrollLeft) < Math.abs(stops[current] - row.scrollLeft)) current = i;
    }
    var target = Math.max(0, Math.min(stops.length - 1, current + Number(button.dataset.xsDir)));
    // skip stops that are clamped to the same end position
    while (target > 0 && target < stops.length - 1 && stops[target] === stops[current]) {
      target += Number(button.dataset.xsDir);
    }
    row.scrollTo({ left: stops[target], behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var row = event.target;
      if (row && row.matches && row.matches(ROW)) sync(row);
    },
    true
  );

  // Re-sync as soon as a row gets its real size (drawer opened, images laid out)
  var sized = typeof ResizeObserver === 'function'
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (entry) { sync(entry.target); });
      })
    : null;
  var observed = typeof WeakSet === 'function' ? new WeakSet() : null;

  function watchRows() {
    if (!sized) return;
    document.querySelectorAll(ROW).forEach(function (row) {
      if (observed && observed.has(row)) return;
      if (observed) observed.add(row);
      sized.observe(row);
    });
  }

  // Re-sync after the drawer is re-rendered (quick buy, quantity change, ...).
  // Only mutations inside the cart drawer / cart page count - the rest of the
  // page (hero video, lazy images, sliders) must not trigger layout reads.
  var SCOPE = '.cart-drawer__cross-sell, cart-drawer-component, .cart-drawer, cart-items-component';
  function relevant(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var node = mutations[i].target;
      var el = node.nodeType === 1 ? node : node.parentElement;
      if (el && el.closest && el.closest(SCOPE)) return true;
    }
    return false;
  }
  var queued = false;
  new MutationObserver(function (mutations) {
    if (queued || !relevant(mutations)) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      watchRows();
      syncAll();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Drawer open (dialog/details toggle) - sync on the next frame, when laid out
  document.addEventListener(
    'toggle',
    function () {
      requestAnimationFrame(syncAll);
    },
    true
  );

  window.addEventListener('resize', syncAll);
  watchRows();
  syncAll();
})();
